import React, { useRef, useState } from 'react';
import styled from 'styled-components';
import { useLanguage } from '../../../Context/LanguageContext';

import BlackPencelIcon from '../../../image/BlackPencel.svg';
import BlackExitIcon from '../../../image/BlackExit.svg';

import HoverArrow from '../../../image/IndexChangeArrowHover.png';
import NonHoverArrow from '../../../image/IndexChangeArrowNonHover.png';
import ComponentHoverArrow from '../../../image/IndexChangeArrowComponentHover.png';
import WhiteArrow from '../../../image/IndexChangeArrowWhite.png';

export default function MemberShipInfoBox(props) {
  const { 
    data, 
    index,
    isClickedMemberShipEdit, 
    onClickEditMemberShipButton, 
    onClickDeletedMemberShip,
    onClickChangeIndex,
  } = props;
  const { t } = useLanguage();

  const [arrowUpIcon, setArrowUpIcon] = useState(ComponentHoverArrow);
  const [arrowDownIcon, setArrowDownIcon] = useState(ComponentHoverArrow);

  const [isHoverArrowUp, setIsHoverArrowUp] = useState(false);
  const [isHoverArrowDown, setIsHoverArrowDown] = useState(false);

  const PencelRef = useRef();
  const ExitRef = useRef();

  // 회원권 정보 클릭시 //
  function onClickEditMemberShip(e) {
    // if (isClickedMemberShipEdit || ExitRef.current === e.target) return;
    if (ExitRef.current === e.target) return;

    onClickEditMemberShipButton(data);
  }

  // 위로이동 화살표 호버링 //
  function onMouseOverArrowUp() {
    setIsHoverArrowUp(true);
  }

  // 위로이동 화살표 호버링 //
  function onMouseLeaveArrowUp() {
    setIsHoverArrowUp(false);
  }

  // 아래로이동 화살표 호버링 //
  function onMouseOverArrowDown() {
    setIsHoverArrowDown(true);
  }

  // 아래로이동 화살표 호버링 //
  function onMouseLeaveArrowDown() {
    setIsHoverArrowDown(false);
  }
  
  // 위로이동 버튼 클릭시 //
  function onClickMoveUp(e) {
    e.stopPropagation(); // ← 버블링 중단!
    onClickChangeIndex('UP', index);
  }

  // 아래로이동 버튼 클릭시 //
  function onClickMoveDown(e) {
    e.stopPropagation(); // ← 버블링 중단!
    onClickChangeIndex('DOWN', index);
  }


  return (
    <TopLevelWrapper isHideAll={data.isHideAll} onClick={onClickEditMemberShip}>
      <TextWrapper>
          <ArrowWrapper>
            <ArrowImageWrapper 
              onMouseOver={onMouseOverArrowUp} 
              onMouseLeave={onMouseLeaveArrowUp} 
              onClick={onClickMoveUp}>
              <ArrowImage opacity={isHoverArrowUp ? 0 : 1} src={arrowUpIcon}/>
              <ArrowImage opacity={isHoverArrowUp ? 1 : 0} src={HoverArrow}/>
            </ArrowImageWrapper>
            <ArrowImageWrapper 
              style={{ transform: 'rotate(-180deg)' }} 
              onMouseOver={onMouseOverArrowDown} 
              onMouseLeave={onMouseLeaveArrowDown}
              onClick={onClickMoveDown}>
              <ArrowImage opacity={isHoverArrowDown ? 0 : 1} src={arrowDownIcon}/>
              <ArrowImage opacity={isHoverArrowDown ? 1 : 0} src={HoverArrow}/>
            </ArrowImageWrapper>
          </ArrowWrapper>
        <Text fontFmaily='NotoSansKR-Medium' fontSize={14} color={data.isHideAll ? '#969696' : '#333333'} cursor='pointer'>{data.name}</Text>
      </TextWrapper>
      <StatusWrapper>
        { data.isHideAll && <Text fontFmaily='NotoSansKR-Medium' fontSize={14} color='#333333' cursor='pointer'>{t('system.private')}</Text> }
      <ImageWrapper>
        {
          data.autoPayment === 1 &&
          <SubscriptBox>
            <Text fontFmaily='NotoSansKR-Medium' fontSize={14} color='#FFFFFF' cursor='pointer'>{t('settingMembership.subscription')}</Text>
          </SubscriptBox>
        }
        <Image ref={ExitRef} src={BlackExitIcon} onClick={() => onClickDeletedMemberShip(data)}/>
      </ImageWrapper>
      </StatusWrapper>
    </TopLevelWrapper>
  )
}

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  min-width: 100%;
  height: 30px;
  
  background-color: #FFFFFF;

  transition: all 0.3s ease-in-out;

  &:hover {
    cursor: pointer;
    // background-color: #F5F5F5;
  }
`;

const StatusWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  gap: 10px;
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  width: 60%;

  gap: 15px;

  overflow: hidden;
`;


const Text = styled.div`
  font-family: ${props => props.fontFmaily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  &:hover {
    cursor: ${props => props.cursor};
  }
`;

const ImageWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  gap: 20px;
`;

const SubscriptBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  padding: 0px 10px;

  border-radius: 5px;
  background-color: #FF8B48;
`;

const Image = styled.img`
  width: 20px;
  height: 20px;

  &:hover {
    cursor: pointer;
  }
`;

const ArrowWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  gap: 10px;
`;

const ArrowImageWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 14px;
  height: 10px;

  transition: all 0.3s ease-in-out;

  &:hover {
    cursor: pointer;
  }
`;

const ArrowImage = styled.img`
  position: absolute;
  width: 100%;
  height: 8px;

  opacity: ${props => props.opacity};

  transition: all 0.3s ease-in-out;

  &:hover {
    cursor: pointer;
  }
`;
